/**
 * Is true when fetch can be used for tracking.
 * @type {Boolean}
 */
const useFetch = (new Request(location.href)).keepalive !== undefined;

/**
 * Sends tracking data to the passed url suck that navigating away from the page
 * will not cancel the request.
 *
 * The data will be sent as `application/x-www-form-urlencoded`.
 * @param {URL} url - The destination of the request.
 * @param {URLSearchParams} data - The data to send.
 */
function send(url, data){
	if (!useFetch){
		navigator.sendBeacon?.(url, data);
		return;
	}

	fetch(url, {
		method: 'POST',
		body: data,
		cache: 'no-store',
		keepalive: true,
		credentials: 'include',
	}).catch(() => {});
}

/**
 * Checks if the a no tracking flag is set. 
 *
 * This is usually set to avoid tracking searches made by the merchant.
 * @return {Boolean} Is true when the flag is present.
 */
function hasNoTrackingFlag(){
	const url = new URL(location.href);
	return url.searchParams.get('notrack') === '1';
}

/**
 * Trys to track the passed search term by passing the value to a tracking 
 * endpoint.
 * @param {String} term - The search term to track.
 */
export function trackSearch(term){
	if (term.trim().length === 0) return;
	if (hasNoTrackingFlag()) return;
	send(new URL('/search/tracking', location.href), new URLSearchParams({term}));
}